module.exports = __webpack_public_path__ + "static/media/g2.34f6dde5.png";